import React, { useState } from 'react';
import "./Login.css";
import SeoHelmets from '../SeoOptimazation/SeoHelmets';
import logo from "../../Image/logo.png";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaFacebookF } from "react-icons/fa";
import { FaTelegramPlane } from "react-icons/fa";
import { useAlert } from 'react-alert';
import { loginUser } from '../DynamicCourse/api';
import { saveCookie, getCookie } from '../../commonServices/cookieService';
import { getUniqueId } from '../../commonServices/commonService';
import { IoMdEye } from "react-icons/io";
import { IoMdEyeOff } from "react-icons/io";

function Login({ setIsLoggedIn, setAuthtoken }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [error, setError] = useState('');
    const alert = useAlert();


    const location = useLocation();
    const navigate = useNavigate();

    // Ensures the browser has a Device ID cookie for later use
    // (We don't send this to the backend during login anymore, 
    // but we need it ready for when they try to access Live Streams)
    function ensureDeviceIdCookie() {
        let deviceId = getCookie('deviceId');
        if (!deviceId) {
            deviceId = getUniqueId();
            saveCookie('deviceId', deviceId);
        }
        return deviceId;
    }

    const handleLogin = async () => {
        setError(''); // Clear previous errors
        if (!email.trim()) {
            setError('Email address is required');
            return;
        }
        if (!password.trim()) {
            setError('Password is required');
            return;
        }

        try {
            // 1. Ensure cookie exists (Client side only)
            ensureDeviceIdCookie();

            // 2. Call Login API (Pure Authentication - No Device ID sent)
            const token = await loginUser({ email, password });
 
            // 3. Save Auth State
            saveCookie('email', email);
            localStorage.setItem('authtoken', email);
            localStorage.setItem('token', token);
 
            setIsLoggedIn(true);
            setAuthtoken(email);

            // 4. Navigate
            alert.show('Logged in successfully');
            navigate(location?.state?.from || '/');

        } catch (error) {
            console.error("Login Error", error);
            setError(error.response?.data?.message || 'Login failed. Please check your credentials.');
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleLogin();
        }
    };

    return (
        <>
            <SeoHelmets 
                title="Student Login - Insight IAS Academy" 
                description="Access your course materials, test series, and dashboard. Secure student login for Insight IAS Academy Delhi." 
                keywords="IAS login, student dashboard login, Insight IAS portal, online UPSC platform login"
            />
            <div className='loginContainer'>
                <div className='loginImage'>
                    <Link to="/">
                        <img src={logo} alt='Insight Delhi Logo' />
                    </Link>
                </div>
                <div className='loginForm'>
                    <div className="card login-card">
                        <div className="card-header m-3 text-center fw-500 text-white login-heading">
                            Login to your Account
                        </div>
                        <div className="card-body">
                            <form onSubmit={(e) => e.preventDefault()}>
                                <div className="mb-3">
                                    <label htmlFor="emailInput" className="form-label">Email ID</label>
                                    <input
                                        type="email"
                                        className="form-control text-lowercase"
                                        id="emailInput"
                                        placeholder='Your email-id'
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value.toLowerCase())}
                                        onKeyDown={handleKeyDown}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="passwordInput" className="form-label">Password</label>
                                    <div className="d-flex justify-content-between align-items-center position-relative">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            className="form-control"
                                            id="passwordInput"
                                            placeholder='Password'
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            onKeyDown={handleKeyDown}
                                        />
                                        <span
                                            className="position-absolute end-0 me-3"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {showPassword ?
                                                <IoMdEyeOff size={24} onClick={() => setShowPassword(false)} /> :
                                                <IoMdEye size={24} onClick={() => setShowPassword(true)} />
                                            }
                                        </span>
                                    </div>
                                </div>
                                <div className="d-grid gap-2">
                                    <button
                                        className="btn btn-primary login-btn py-2 border-0"
                                        type="button"
                                        onClick={handleLogin}
                                    >
                                        LOGIN
                                    </button>
                                </div>
                            </form>
                            {/* Error message */}
                            {error && <p className='text-danger mt-2 text-center'>{error}</p>}
                        </div>
                        <div className="m-3 login-bottom">
                                                        {/* <div className="card-footer py-3 d-flex justify-content-center login-footer"></div> */}
                            <div className="card-footer py-3 d-flex justify-content-center flex-wrap login-footer">
                                <span className="fw-bold me-1" style={{ color: '#9c0828ff', fontSize: '1.15rem' }}>Forgot Password?</span>
                                <Link className="fw-semibold " style={{ color: '#6f42c1', fontSize: '1.05rem' }} to="/login/forgot">Click here</Link>
                            </div>
                                                        {/* <div className="card-footer py-3 d-flex justify-content-center login-footer"></div> */}
                            <div className="card-footer py-3 d-flex justify-content-center flex-wrap login-footer">
                                <span className="fw-bold me-1" style={{ color: '#9c0828ff', fontSize: '1.15rem' }}>Not a Member?</span>
                                <Link className="fw-semibold " style={{ color: '#6f42c1', fontSize: '1.05rem' }} to="/Registration">Register</Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="login-list">
                    <div className='login-box'>
                        <Link to="/home" className='login-link'>HOME</Link>
                        <Link to="/about" className='login-link'>ABOUT US</Link>
                        <Link to="/civils" className='login-link'>CIVILS</Link>
                        <Link to="#" className='login-link'>NEET</Link>
                        <Link to="#" className='login-link'>CUET</Link>
                        <Link to="#" className='login-link'>UGC-NET</Link>
                        <Link to="/daily-current-affairs/News" className='login-link'>CURRENT AFFAIRS</Link>
                        <Link to="/blogs" className='login-link'>BLOGS</Link>
                    </div>
                    <div className='login2'>
                        <h2 className='text-white'>© 2022 - 2023 Insight Delhi</h2>
                    </div>
                    <div className='login3'>
                        <div><FaFacebookF /></div>
                        <div><FaTelegramPlane /></div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Login;